import { atom } from 'jotai'

/**
 * Headerに追加でレンダリングするためのDOM要素の指定用
 */
export const headerPortalElementAtom = atom<HTMLDivElement | null>(null)

headerPortalElementAtom.debugLabel = 'headerPortalElementAtom'
